import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  listItem: {
    fontSize: 'inherit',
    color: 'inherit',
  },
}));

export default useStyles;
